(function () {
  'use strict';

  var eventNames = {
    help_route_selected: true,
    material_detail_viewed: true,
    material_filter_applied: true,
    material_guide_completed: true,
    material_guide_started: true,
    portal_handoff: true
  };

  var parameterNames = {
    content_section: true,
    cta_id: true,
    cta_label: true,
    filter_name: true,
    filter_value: true,
    guide_application: true,
    guide_appearance: true,
    guide_priority: true,
    help_route: true,
    material_handle: true,
    route_type: true,
    source_page: true,
    template: true
  };

  function readContext() {
    var element = document.getElementById('LLMeasurementContext');
    if (!element) return {};

    try {
      return JSON.parse(element.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  var context = readContext();
  var viewPublished = false;

  function analyticsAllowed() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (
      !customerPrivacy ||
      typeof customerPrivacy.analyticsProcessingAllowed !== 'function'
    ) {
      return false;
    }

    return customerPrivacy.analyticsProcessingAllowed() === true;
  }

  function cleanValue(value) {
    if (value === undefined || value === null) return '';
    return String(value).trim().replace(/\s+/g, ' ').slice(0, 100);
  }

  function cleanPayload(payload) {
    var clean = {};

    Object.keys(payload || {}).forEach(function (key) {
      if (!parameterNames[key]) return;
      var value = cleanValue(payload[key]);
      if (value) clean[key] = value;
    });

    return clean;
  }

  function publish(eventName, payload) {
    if (!eventNames[eventName] || !analyticsAllowed()) return false;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName
        },
        cleanPayload(payload)
      )
    );
    return true;
  }

  function pageKey() {
    return [context.page_type, context.resource_handle]
      .filter(Boolean)
      .join(':')
      .slice(0, 100);
  }

  function sectionKey(element) {
    var section = element.closest('[id^="shopify-section-"]');
    if (!section) return 'global';
    return section.id.replace('shopify-section-', '').slice(0, 100);
  }

  function portalRoute(url) {
    if (url.pathname.indexOf('/account') === 0) return 'account';
    if (url.pathname.indexOf('/samples') === 0) return 'sample_order';
    return 'direct_order';
  }

  function portalLink(element) {
    var link = element.closest('a[href]');
    if (!link) return null;

    try {
      var url = new URL(link.href, window.location.origin);
      return url.hostname === 'app.laserlokaal.nl'
        ? { link: link, url: url }
        : null;
    } catch (error) {
      return null;
    }
  }

  function publishMaterialView() {
    if (viewPublished || !document.querySelector('.ll-material-detail')) return;

    viewPublished = publish('material_detail_viewed', {
      source_page: pageKey(),
      template: context.template,
      material_handle: context.resource_handle
    });
  }

  document.addEventListener('click', function (event) {
    var portal = portalLink(event.target);
    if (!portal) return;

    var routeType = portalRoute(portal.url);
    publish('portal_handoff', {
      source_page: pageKey(),
      template: context.template,
      content_section: sectionKey(portal.link),
      cta_id:
        portal.link.getAttribute('data-measurement-id') ||
        routeType + ':' + sectionKey(portal.link),
      cta_label: portal.link.textContent,
      route_type: routeType,
      material_handle: context.page_type === 'product' ? context.resource_handle : ''
    });
  });

  document.addEventListener('change', function (event) {
    var field = event.target.closest(
      'input[name^="filter."], select[name^="filter."]'
    );
    if (!field) return;

    publish('material_filter_applied', {
      source_page: pageKey(),
      filter_name: field.name,
      filter_value:
        field.type === 'checkbox' && !field.checked ? 'removed' : field.value
    });
  });

  document.addEventListener('visitorConsentCollected', publishMaterialView);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', publishMaterialView);
  } else {
    publishMaterialView();
  }

  window.LaserLokaalMeasurement = {
    analyticsAllowed: analyticsAllowed,
    publish: publish
  };
  document.documentElement.setAttribute('data-ll-measurement-ready', 'true');
})();
